import React from 'react';
import {
  Compass,
  ShoppingBag,
  Tag,
  Home,
  Gift,
  Store,
  BadgeCheck,
  UserRound,
  type LucideIcon,
} from 'lucide-react';
import { LEARN_ICON_OPTIONS, type LearnIcon } from '@/client/types/learn';

export const LEARN_ICON_MAP: Record<LearnIcon, LucideIcon> = {
  compass: Compass,
  'shopping-bag': ShoppingBag,
  tag: Tag,
  home: Home,
  gift: Gift,
  store: Store,
  'badge-check': BadgeCheck,
  'user-round': UserRound,
};

export function getLearnIconComponent(iconName?: string | null): LucideIcon {
  if (iconName && iconName in LEARN_ICON_MAP) {
    return LEARN_ICON_MAP[iconName as LearnIcon];
  }
  return Compass;
}

interface LearnIconPickerProps {
  value: string;
  onChange: (value: LearnIcon) => void;
  disabled?: boolean;
}

export const LearnIconPicker: React.FC<LearnIconPickerProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const selectedIcon = (value && value in LEARN_ICON_MAP ? value : 'compass') as LearnIcon;
  const CurrentIcon = LEARN_ICON_MAP[selectedIcon];

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
        <CurrentIcon className="h-4 w-4" />
      </div>
      <select
        value={selectedIcon}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e.target.value as LearnIcon)}
        disabled={disabled}
        className="w-full rounded-md border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-100 disabled:opacity-50"
      >
        {LEARN_ICON_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
